import getTopArticle from './components/toparticle';
import getFeed from './components/feed';
import getCallouts from './components/callout';
import getTopicsWidg from './components/topics';
import getCalcWidg from './components/calculators';
import getConsultWidg from'./components/consult';
import getSalaryWidg from './components/salgraph';
import getCmeGlider from './components/cmeglider';
import './components/scrollrefresh';
import './components/ads';
import './components/comments';
import './components/cme';
import './components/thirdparty';
import './components/share';
import './components/likes';
// import './components/saved';
import './components/feedback';
// import './components/email';

getCallouts();
getTopArticle();
getFeed();
getCmeGlider();
getConsultWidg();
getCalcWidg();
getTopicsWidg();
if (document.getElementById('salary-explorer-widget') != null) getSalaryWidg();